import React from 'react';
import './AdminStats.css';

const AdminStats = ({ stats }) => {
  const statCards = [
    { icon: 'fa-solid fa-calendar-check', label: 'Total Requests', value: stats.total, color: 'primary' },
    { icon: 'fa-solid fa-clock', label: 'Pending', value: stats.pending, color: 'warning' },
    { icon: 'fa-solid fa-check-circle', label: 'Approved', value: stats.approved, color: 'success' },
    { icon: 'fa-solid fa-times-circle', label: 'Rejected', value: stats.rejected, color: 'danger' },
    { icon: 'fa-solid fa-ban', label: 'Cancelled', value: stats.cancelled, color: 'secondary' },
    { icon: 'fa-solid fa-hourglass-half', label: 'Waitlist', value: stats.waitlist, color: 'info' },
    { icon: 'fa-solid fa-location-dot', label: 'Location Changed', value: stats.locationChanged, color: 'purple' },
    { icon: 'fa-solid fa-calendar-day', label: 'Today', value: stats.today, color: 'orange' },
    { icon: 'fa-solid fa-calendar-week', label: 'This Week', value: stats.thisWeek, color: 'teal' },
    { icon: 'fa-solid fa-calendar-month', label: 'This Month', value: stats.thisMonth, color: 'indigo' },
    { icon: 'fa-solid fa-cross', label: 'Religious', value: stats.religious, color: 'purple-light' },
    { icon: 'fa-solid fa-landmark', label: 'Political', value: stats.political, color: 'brown' },
    { icon: 'fa-solid fa-medal', label: 'Sporting', value: stats.sporting, color: 'green' },
    { icon: 'fa-solid fa-toolbox', label: 'Equipment', value: stats.equipment, color: 'blue' },
    { icon: 'fa-solid fa-building', label: 'Facilities', value: stats.facilities, color: 'cyan' },
    { icon: 'fa-solid fa-id-card', label: 'Memberships', value: stats.memberships, color: 'pink' }
  ];

  return (
    <div className="admin-stats">
      <h3 className="stats-title">
        <i className="fa-solid fa-chart-simple"></i>
        Overview
      </h3>
      <div className="stats-grid">
        {statCards.map((stat, index) => (
          <div key={index} className={`stat-card ${stat.color}`}>
            <div className="stat-icon">
              <i className={stat.icon}></i>
            </div>
            <div className="stat-content">
              <span className="stat-value">{stat.value}</span>
              <span className="stat-label">{stat.label}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminStats;